export enum CompanyTypeEnum {
  BBL = 'BBL', // Boligbyggerlag
  BRL = 'BRL', // Borettslag
  ESS = 'ESS', // Eierseksjonsameie
  BAS = 'BAS', // Boligaksjeselskap
  AS = 'AS', // Aksjeselskap
  TRS = 'TRS', // Tingsrettsligsameie,
  SA = 'SA', // Samvirke
  STI = 'STI', // Stiftelse
  FO = 'FO', // Forening
}

export interface SimpleClient {
  id: string
  no: number
  name: string
  sortKey?: string
}
